import type { ITheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import { createCustomizedThemeWithSlotOverrides } from '@ms/yammer-web-core-ui/dist/util/theme';
import type { Theme } from '@ms/yammer-web-core-ui/dist/util/theme/fluent9';
import { useMemo } from 'react';

const teamsFontFamily = `-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, "Apple Color Emoji", "Segoe UI Emoji", sans-serif`;

type UseThemeWithTeamsOverridesForV8 = (theme: ITheme) => ITheme;
export const useThemeWithTeamsOverridesForV8: UseThemeWithTeamsOverridesForV8 = (theme) =>
  useMemo(
    () =>
      createCustomizedThemeWithSlotOverrides({
        name: 'yammerTeamsMeeting',
        theme,
        paletteOverrides: theme?.palette,
        semanticColorOverrides: theme?.semanticColors,
        fontOverrides: {
          tiny: {
            fontFamily: teamsFontFamily,
          },
          xSmall: {
            fontFamily: teamsFontFamily,
          },
          small: {
            fontFamily: teamsFontFamily,
          },
          smallPlus: {
            fontFamily: teamsFontFamily,
          },
          medium: {
            fontFamily: teamsFontFamily,
          },
          mediumPlus: {
            fontFamily: teamsFontFamily,
          },
          large: {
            fontFamily: teamsFontFamily,
          },
          xLarge: {
            fontFamily: teamsFontFamily,
          },
        },
      }),
    [theme]
  );

type UseThemeWithTeamsOverridesForV9 = (theme: Theme) => Theme;
export const useThemeWithTeamsOverridesForV9: UseThemeWithTeamsOverridesForV9 = (theme) =>
  useMemo(
    () => ({
      ...theme,
      fontFamilyBase: teamsFontFamily,
      fontFamilyMonospace: `'Cascadia Mono', Consolas, ui-monospace, Menlo, Monaco, monospace`,
    }),
    [theme]
  );
